import { AuthorizationWrapper } from '@frontend/authorization';
import { EntityType, Rights } from '@frontend/common';
import { IUser } from '@frontend/user/types';
import { User } from '@frontend/user/utils';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import { SupervisedUsersCardProps, useSupervisedUsersCard } from './supervised-users-card.controller';

export const SupervisedUsersCard = (props: SupervisedUsersCardProps) => {
    const viewProps = useSupervisedUsersCard(props);

    return (
        <AuthorizationWrapper
            requiredPermissions={[
                { item: EntityType.USER, source: EntityType.ACCOUNT, right: Rights.READ, uid: props.account_id },
                { item: EntityType.USER, source: EntityType.USER, right: Rights.READ, uid: props.entity_id }
            ]}>
            <DefaultContainer
                title={
                    <FormattedMessage
                        id='platform.user-detail.supervised-users'
                        description='Card title for users supervised by the selected user in the platform user detail modal'
                        defaultMessage='Supervised users'
                    />
                }
                content={
                    <div className='flex flex-wrap gap-2'>
                        {viewProps.users.map((user: IUser) => (
                            <PlatformObjectBadge
                                key={user.id}
                                entityType={EntityType.USER}
                                id={user.id}
                                display={new User(user).getDisplayName()}
                            />
                        ))}
                    </div>
                }
            />
        </AuthorizationWrapper>
    );
};
